module.exports = __webpack_public_path__ + "img/two-inc.755fce37.png";